/**
 * Session cache for Settings → Widget settings API payload (`data` object).
 * Survives leaving the page; revisit shows last settings while refetching.
 */

const emptyCache = () => ({
  businessId: null,
  /** Last successful `payload.data` from getWidgetSettings */
  data: null,
  hasFetched: false,
});

let cache = emptyCache();

export function getWidgetSettingsWarmCache() {
  return cache;
}

export function setWidgetSettingsWarmCache(next) {
  let data = next.data;
  if (data != null && typeof data === "object") {
    try {
      data = JSON.parse(JSON.stringify(data));
    } catch {
      // keep reference if not serializable
    }
  }
  cache = {
    ...emptyCache(),
    ...next,
    data,
  };
}

export function clearWidgetSettingsWarmCache() {
  cache = emptyCache();
}
